module.exports = __webpack_public_path__ + "static/media/39-1.06ce6ed3.mp3";